<template>
  <div class="images-grid">
    <ul class="images-grid-list">
      <li v-for="image in images" :key="image.id" class="images-grid-item">
        <img
          :src="image.url"
          :alt="image.alt"
          loading="lazy"
          class="images-grid-image"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PagesStudioImagesGrid',
}
</script>

<script setup>
const props = defineProps({
  images: {
    type: Array,
    default: () => [],
  },
})
</script>

<style lang="scss">
@import './style.scss';
</style>
